<template>
    <section class="app-main">
      <el-tabs v-model="activeName" v-if="children && children.length>0" @tab-click="handleClick" style="width: 1105px;">
        <el-tab-pane :label="item.text" :key="item.path" :name="item.path" v-for="item in children" v-if="!item.hidden && !(item.path=='lock' && !isPromotorDisplay)">
        </el-tab-pane>
        <div class="page-container">
          <transition name="fade" mode="out-in">
              <router-view :key="key"></router-view>
          </transition>
        </div>
      </el-tabs>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'AppMain',
  data(){
    return{
      activeName: 'first',
      children:[],
      parent_path: '',
      permission_routers:this.$store.getters.permission_routers
    }
  },
  computed: {
    ...mapGetters([
      'isPromotorDisplay'
    ]),
    key() {
      return this.$route.name !== undefined
                    ? this.$route.name + +new Date()
                    : this.$route + +new Date()
    }
  },
  mounted(){
    this.fetchData();
  },
  methods:{
    fetchData(){
      let vis = this
      let route_path = this.$route.path
      // let parent_path = `/${route_path.split('/')[1]}`
      let tmpIdx = route_path.lastIndexOf('/')
      let parent_path = route_path.slice(0, tmpIdx)
      vis.parent_path = parent_path
      vis.permission_routers.forEach( (item) => {
        if(item.path == parent_path){
          vis.children = item.children
          item.children.forEach((child,index)=>{
            if(`${parent_path}/${child.path}` == route_path){
              vis.activeName = child.activeName || child.path
            }
          })
        }
      })
    },
    handleClick(){
      let props = arguments[0]
      this.$router.push(`${this.parent_path}/${props.name}`)
    }
  },
  watch:{
    '$route': 'fetchData'
  }
}
</script>

<style lang="scss" scoped>
.app-main{
  overflow-x: auto;
  overflow-y: scroll;
  background-color: #f3f4f5;
  height: calc(100vh - 50px);
  .page-container{
    padding: 10px 0px 0px 10px;
  }
}
</style>





// WEBPACK FOOTER //
// AppMain.vue?2cec456a